import Actions from "../../../../Actions";

export const useLogoRequired = () => {
  return { checkLogoRequired };
};

export const checkLogoRequired = (
  { logo },
  organizationLogo,
  channel,
  postNumber,
  isReleased,
  userName,
  tbCampaignId
) => {
  const defaultAvatarUrl = "https://eu.ui-avatars.com/";
  const isLogoSelected = logo && !logo.includes(defaultAvatarUrl);

  if (isLogoSelected) {
    return;
  }

  const newLogo = organizationLogo || "";

  Actions.updatePost({
    channelShortName: channel,
    postNumber: postNumber,
    isReleased,
    userName,
    updateData: { logo: newLogo },
    campaignId: tbCampaignId
  });
};
